import { Stack } from '@mui/joy';
import { ColDef, IRowNode } from 'ag-grid-community';

import { IExtractorVendorMapping } from 'companySettings/types';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';

interface IProps {
  colDef?: ColDef;
  data?: IExtractorVendorMapping;
  node?: IRowNode<IExtractorVendorMapping>;
}

export const VendorCell = ({ colDef, data, node }: IProps) => {
  // Grouping by Vendor makes AG Grid reuse this renderer inside the auto group column, on a row
  // with no data — without the branch below that row would show its count and no name.
  //
  // The gate has to be the CELL, not the row: `groupDisplayType: 'multipleColumns'`
  // (core/utils/agGridTable.ts) leaves every ordinary column rendering on every group row, also
  // dataless, and `node.key` there belongs to whichever column grouped it — so a row grouped by
  // Updated By would otherwise print the user's name in this cell too. Only an auto group column's
  // colDef carries `showRowGroup`, set to the id of the column it stands in for, and AG Grid runs
  // the grouped column's renderer solely in the auto column displaying that group level.
  //
  // It renders the node KEY rather than the cell value because a group row has no data to read the
  // name off: the key is the value AG Grid grouped the rows by, which for this column is the vendor
  // name the leaf cells show.
  if (!data) {
    return 'vendor' === colDef?.showRowGroup && node?.key ? (
      <TextLine text={node.key} textEllipsis />
    ) : null;
  }

  // The AP number lives in the Vendor Location column, so an unmapped extractor — or the ERP name
  // being empty — would leave this cell entirely blank without the placeholder.
  // The Stack is load-bearing: TextLine's row flex inherits `justify-content`, so as the cell's
  // root it picks up the `center` that `.ag-cell` (core AgGridTable style.css) sets for vertical
  // centring and centres the text horizontally.
  return (
    <Stack>
      <TextLine text={data.vendor?.name || DEFAULT_PLACEHOLDER} textEllipsis />
    </Stack>
  );
};
